import React, { useEffect, useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  Alert,
  Typography,
  CircularProgress,
} from '@mui/material'
import moment from 'moment'

// Confirmation for removing someone from an activity, either a participant or a queued
// person, with the refund decision the backend needs. onConfirm receives the refund boolean.
//
// The refund box defaults to CHECKED only when the person actually has a payment on this
// activity - a queued person normally has none, and defaulting to a refund that has nothing
// to refund invites an accidental one.
function ActivityRemoveDialog({ open, target, activity, removing, error, onClose, onConfirm }) {
  const [refund, setRefund] = useState(false)

  const person = target && target.person
  const queued = !!(target && target.kind === 'queued')

  // payments[] hangs off the activity and is matched to a person by uid.
  const payments =
    person && activity && Array.isArray(activity.payments)
      ? activity.payments.filter((p) => p.uid === person.id)
      : []

  useEffect(() => {
    if (open) setRefund(payments.length > 0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, target])

  const name = person ? [person.firstname, person.lastname].filter(Boolean).join(' ') : ''
  const paymentsText = payments
    .map((p) => {
      const when = moment(p.timestamp, ['YYYY.MM.DD HH:mm', 'YYYY-MM-DD HH:mm:ss']).format('DD.MM.YYYY HH:mm')
      const sum = typeof p.amount === 'number' ? (p.amount / 100).toFixed(2).replace('.', ',') + ' €' : ''
      return [when, p.typelabel || p.type, sum].filter(Boolean).join(' ')
    })
    .join(', ')

  return (
    <Dialog open={!!open} onClose={removing ? undefined : onClose} fullWidth maxWidth='xs'>
      <DialogTitle>{queued ? 'Poista jonosta' : 'Poista osallistuja'}</DialogTitle>
      <DialogContent>
        <div style={{ marginBottom: 12 }}>
          Poistetaanko <b>{name}</b> {queued ? 'aktiviteetin jonosta' : 'aktiviteetin osallistujista'}?
        </div>

        {payments.length > 0 ? (
          <Alert severity='info' style={{ marginBottom: 12 }}>
            {payments.length === 1 ? 'Maksu' : payments.length + ' maksua'}: {paymentsText}
          </Alert>
        ) : (
          <Typography variant='body2' color='textSecondary' style={{ marginBottom: 12 }}>
            Henkilöllä ei ole maksua tälle aktiviteetille.
          </Typography>
        )}

        <FormControlLabel
          control={
            <Checkbox checked={refund} onChange={(e) => setRefund(e.target.checked)} disabled={removing} />
          }
          label='Palautetaanko maksu?'
        />

        {error && (
          <Alert severity='error' style={{ marginTop: 12 }}>
            Poisto epäonnistui: {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onConfirm(refund)} color='error' disabled={removing}>
          {queued ? 'Poista jonosta' : 'Poista osallistuja'} {removing ? <CircularProgress size={12} /> : ''}
        </Button>
        <Button onClick={onClose} disabled={removing}>
          Peruuta
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ActivityRemoveDialog
